import PlayPositions from "./PlayPositions";

const PlayPositionsShortnameMap = {
  [PlayPositions.GOALKEEPER]: "GK",
  [PlayPositions.LEFT_FULLBACK]: "LB",
  [PlayPositions.CENTER_BACK]: "CB",
  [PlayPositions.LEFT_CENTER_BACK]: "LCB",
  [PlayPositions.RIGHT_CENTER_BACK]: "RCB",
  [PlayPositions.RIGHT_FULLBACK]: "RB",
  [PlayPositions.CENTER_MIDFIELDER]: "CM",
  [PlayPositions.LEFT_CENTER_MIDFIELDER]: "LCM",
  [PlayPositions.RIGHT_CENTER_MIDFIELDER]: "RCM",
  [PlayPositions.DEFENSIVE_MIDFIELDER]: "CDM",
  [PlayPositions.ATTACKING_MIDFIELDER]: "AM",
  [PlayPositions.STRIKER]: "ST",
  [PlayPositions.LEFT_WINGER]: "LW",
  [PlayPositions.RIGHT_WINGER]: "RW",
};

export default PlayPositionsShortnameMap;